/* data-transformation.ts */

export const replaceBooleanStrings = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(replaceBooleanStrings);
  } else if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        replaceBooleanStrings(value),
      ])
    );
  } else if (obj === "True") {
    return "Diagnosed";
  } else if (obj === "False") {
    return "Not diagnosed";
  }
  return obj;
};
